import React, { ReactNode } from "react"
import { Download } from "lucide-react"
import QuestionArtifacts from "../../../../component/questionArtifacts/QuestionArtifacts"
import {
  displayableArtifacts,
  type ArtifactLike,
} from "../../../../utils/generatedArtifacts"
import EmptyState from "./EmptyState"
import "./ResourceHtmlFrame.style.scss"

interface ResourceHtmlFrameProps {
  title: string
  available: boolean
  content: string | null
  artifacts?: ArtifactLike[] | null
  emptyLabel?: string
  icon?: ReactNode
  tall?: boolean
  /** Show Download control when resource can be saved. */
  onDownload?: () => void
  downloadDisabled?: boolean
}

const ResourceHtmlFrame = ({
  title,
  available,
  content,
  artifacts,
  emptyLabel = "Content not available for this question.",
  icon,
  tall,
  onDownload,
  downloadDisabled,
}: ResourceHtmlFrameProps) => {
  const hasHtml = Boolean(content?.trim())
  const hasArtifacts = displayableArtifacts(artifacts).length > 0
  const showBody = available && (hasHtml || hasArtifacts)

  return (
    <div className={`resource-html-frame ${tall ? "is-tall" : ""}`}>
      <div className="resource-html-frame__header">
        <h3>
          {icon}
          {title}
        </h3>
        {onDownload && (
          <button
            type="button"
            className="resource-html-frame__download"
            onClick={onDownload}
            disabled={downloadDisabled || !available}
            aria-label={`Download ${title}`}
          >
            <Download size={14} />
            <span>Download</span>
          </button>
        )}
      </div>
      <div className="resource-html-frame__body">
        {!showBody ? (
          <EmptyState title={emptyLabel} />
        ) : (
          <div className="resource-html-frame__content">
            {hasHtml ? (
              <div dangerouslySetInnerHTML={{ __html: content || "" }} />
            ) : null}
            <QuestionArtifacts artifacts={artifacts} />
          </div>
        )}
      </div>
    </div>
  )
}

export default ResourceHtmlFrame

